import { render, staticRenderFns } from "./recependAuditAction.vue?vue&type=template&id=487b6dfa&scoped=true"
import script from "./recependAuditAction.vue?vue&type=script&lang=js"
export * from "./recependAuditAction.vue?vue&type=script&lang=js"
import style0 from "./recependAuditAction.vue?vue&type=style&index=0&id=487b6dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487b6dfa",
  null
  
)

export default component.exports